import {Component, EventEmitter, OnInit, Output, Input, HostBinding} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DataService} from 'src/app/_services/data.service';
import {Options} from '@angular-slider/ngx-slider';


@Component({
    selector: 'app-floors-choice',
    templateUrl: './floors-choice.component.html',
    styleUrls: ['./floors-choice.component.scss']
})
export class FloorsChoiceComponent implements OnInit {

    // @Output() public floorsNumbersRange = new EventEmitter();
    bUid: string;
    floors: any;
    value: number = 0;
    highValue: number = 100;
    options: Options = {
        floor: 0,
        ceil: 0,
        step: 1,
        showTicks: false,
        noSwitching: true
    };
    startSlider: boolean = false;
    newValue: any[] = [];


    constructor(public dataService: DataService,
                private route: ActivatedRoute,
                private router: Router) {
        // this.bUid = params['buid'];
        this.bUid = this.route.snapshot.params.buid;
    }


    ngOnInit(): void {
        //floorsNumbers
        this.dataService.getSpecBuilding(this.bUid).subscribe(building => {
            if (building[0]) {
                this.floors = building[0].floors.filter(n => n);


                const floorsNumbers = this.floors.map(floor => {
                    return floor.floor.number;
                })

                floorsNumbers.sort((a: any, b: any) => {
                    if (a < b) {
                        return -1;
                    } else if (a > b) {
                        return 1;
                    } else {
                        return 0;
                    }
                });

                let from = floorsNumbers[0];
                let until = floorsNumbers[floorsNumbers.length - 1];

                this.value = Number(from);
                this.highValue = Number(until);

                // Due to change detection rules in Angular, we need to re-create the options object to apply the change
                const newOptions: Options = Object.assign({}, this.options);
                newOptions.ceil = until;
                newOptions.floor = from;
                this.options = newOptions;
                if (until > 0) {
                    this.startSlider = true;
                }
                let arrayForEmmiting = [];
                arrayForEmmiting.push(from);
                arrayForEmmiting.push(until);
                this.dataService.saveFloorsNumbers(arrayForEmmiting);
                // this.floorsNumbersRange.emit(arrayForEmmiting);
            }
        });

    }

    testF(value) {
        this.dataService.saveFloorsNumbers([value[0], value[1]]);
    }

    // filter(value){
    //   this.dataService.saveFloorsNumbers([value[0], value[1]]);
    // }
    // testF(value, type) {
    //   let first = 0;
    //   let last = 0;

    //   if(type === 'first'){
    //     this.arrayVal[0] = value;
    //   } else {
    //     this.arrayVal[1] = value;
    //   }
    //   setTimeout(() => {
    //       this.dataService.saveFloorsNumbers(this.arrayVal);
    //   }, 300)
    // }

}
